import React, { Component } from 'react';
import { Button } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Submit extends Component {
  next() {
    this.props.next();
  }

  render() {
    const { translate, previous } = this.props;

    return (
      <div className="Submit">
        <h1>{translate('fiche.submit.title')}</h1>
        <p style={{ whiteSpace: 'pre-line' }}>
          {translate('fiche.submit.body')}
        </p>
        <Button solid className="Form__Button" onClick={() => this.next()}>
          {translate('fiche.submit.save')}
        </Button>
        <Button transparant className="Form__Button" onClick={() => previous()}>
          {translate('fiche.previous')}
        </Button>
      </div>
    );
  }
}

export default withTranslations(Submit);
